<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">LES ASSESSEURS RESTANTS</h3>
      </div>

      <div class="dark-blue">
        <p class="text-md" style="margin: 5px 0px 5px 0px;">
          Les noms des assesseurs enregistrés sont affichés ci-dessous.
        </p>
      </div>

      <div>
        <div style="display: flex; justify-content: flex-end;">
          <button *ngIf="canResendAssessors; else cantResend" class="discreet-button pointer"
            (click)="relaunchAssessors.emit()">
            {{'TIMER.ASS-RELAUNCH' | translate}}
          </button>
          <ng-template #cantResend>
            <button class="discreet-button">{{'POLL-PLANNED.ASS-RESEND-TIME' | translate}} -
              {{remainingAssessorTime}}</button>
          </ng-template>
        </div>
        <div class="voters-container p-10">
          <div *ngFor="let entry of assessorStatusMap | keyvalue; let i = index">
            <div class="flex align-items-base" style="margin-bottom: 15px;">
              <p class="text-md dark-blue bold no-margin" style="margin-right: 10px;">{{i + 1}}.</p>
              <div class="flex content-between w-full">
                <div>
                  <p class="no-margin text-md dark-blue">{{names[emails.indexOf(entry.key)]}}</p>
                  <p class="no-margin text-sm dark-blue opacity-60">{{entry.key}}</p>
                </div>
                <div class="flex gap-10 align-items">
                  <app-custom-tag [isValidated]="true" [text]="''"
                    [backgroundColor]="entry.value ? '#D2F8DD' : '#FFFBEC'"
                    [textColor]="entry.value ? '#166534' : '#F56D24'"
                    [icon]="entry.value ? 'assets/valid-green-icon.svg' : 'assets/clock-orange-icon.svg'">
                  </app-custom-tag>
                  
                  <v8te-active-button [buttonText]="'Renvoyer email'" [boxShadow]="'0px 3px 6px #00000008'"
                    [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'none'"
                    [icon]="'assets/mail-dark-blue.svg'" [iconAlt]="'mail icon'"
                    (click)="relaunchSingleAssessorEvent.emit(entry.key)" [height]="'40px'" [minWidth]="'180px'"
                    [width]="'180px'"></v8te-active-button>

                  <v8te-active-button [buttonText]="'Modifier email'" [boxShadow]="'0px 3px 6px #00000008'"
                    [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'none'"
                    [icon]="'assets/pen-icon.svg'" [iconAlt]="'pen icon'" (click)="updateAssessorEvent.emit(entry.key)"
                    [height]="'40px'" [minWidth]="'180px'" [width]="'180px'"></v8te-active-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
          <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Fermer</p>
        </div>
      </div>
    </div>
  </div>
</div>